import * as React from "react";
import { ReadOnlyFieldSchema } from "@generation/core/src/Schema/Fields";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { useFormContext, useWatch } from "react-hook-form";
import { IInputFieldProps, useGetDatasourceOptions } from "@generation/core";
import { withRegisterFieldHoc } from "../Hoc/withRegisterFieldHoc";
import { useFieldRenderContext } from "../Index";

function getItemFilterByValue(inputValue) {
  return function itemFilter(item) {
    return item.value === inputValue;
  };
}

export const ReadItem = withRegisterFieldHoc(
  withRenderFieldHoc((props: IInputFieldProps<ReadOnlyFieldSchema>): JSX.Element => {
    const renderFieldContext = useFieldRenderContext();

    if (!renderFieldContext) {
      return <></>;
    }

    const { watch } = useFormContext();

    const { options } = useGetDatasourceOptions({
      field: props.field,
      name: props.name,
      getValue: watch
    });

    const value = useWatch({ name: props.name });
    if (options && (props.field.options || props.field.datasource)) {
      const filtered = options.find(getItemFilterByValue(value));
      if (filtered) {
        const { render } = props.field;
        const renderValue = render?.(filtered.label) ?? filtered.label;
        return <renderFieldContext.readItem value={renderValue} />;
      }
    }

    const { formatValue, render } = props.field;
    const formattedValue = formatValue?.(value) ?? value;
    const renderValue = render?.(formattedValue) ?? formattedValue;

    return <renderFieldContext.readItem value={renderValue} />;
  })
);
